import ClipboardJs from "clipboard";

class @App.Components.CopyToClipboard
  constructor: ->
    # mouseover hints
    $('.js-clipboard').each ->
      el = $(@)
      if el.data('clipboard-hint')
        el.on 'mouseover', (e) ->
          el
            .attr('title', el.data('clipboard-hint'))
            .tooltip('fixTitle')
            .tooltip('show')

        el.on 'mouseout', (e) ->
          el
            .attr('title', el.data('clipboard-hint'))
            .tooltip('fixTitle')
            .tooltip('hide')

    # https://clipboardjs.com/
    clipboard = new ClipboardJs('.js-clipboard')
    clipboard.on 'success', (e) ->
      el = $(e.trigger)

      if el.data('clipboard-text-target')
        el.hide().text("Copied!").fadeIn "1000", "easeInExpo"
      else
        el
          .attr('title', el.data('clipboard-copied-text'))
          .tooltip('fixTitle')
          .tooltip('show')

        setTimeout ->
          el.tooltip('hide')
        , 1800

      if el.data('track-action')
        ga(
          'send',
          'event',
          el.data('track-category'),
          el.data('track-action'),
          el.data('track-label')
        )

      el.blur()
      e.clearSelection()

      return

$(document).on 'turbo:load', ->
  new App.Components.CopyToClipboard
